<template>
  <div>
    <v-row>
      <v-col cols="12">
        <fractional-bar :data="fractionalData" />
      </v-col>

      <v-col cols="12">
        <v-card
          elevation="0"
          class="rounded-lg pa-1"
          outlined
          style="background: transparent;"
        >
          <template>
            <v-data-table
              :headers="headers"
              :items="globalMonitorData"
              hide-default-footer
              style="background: transparent;"
              class="striped"
              item-class="row-class"
              mobile-breakpoint=""
              :items-per-page="20"
            >
              <template
                v-if="globalMonitorData.length"
                #body="{ items }"
              >
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    :key="index"
                    :class="{'font-weight-bold': item.firstRow}"
                    :id="item.id"
                  >
                    <td class="px-0">
                      <v-row
                        justify="start"
                        no-gutters
                        align="center"
                      >
                        <v-col cols="4">
                          <v-badge
                            :color="item.color"
                            inline
                          />
                        </v-col>

                        <v-col cols="8">
                          <span>
                            {{ item.title }}
                          </span>
                        </v-col>
                      </v-row>
                    </td>
                    <td align="end">
                      {{ item.count }}
                    </td>
                    <td>
                      {{ item.wctPresentation }}
                    </td>
                    <td>
                      {{ item.lastTouchPresentation }}
                    </td>
                    <td align="end">
                      {{ item.average }}
                    </td>
                    <td align="end">
                      {{ item.averageVariation }}
                    </td>
                    <td align="end">
                      {{ item.intervalAverageCount5s }}
                    </td>
                    <td align="end">
                      {{ item.intervalAverageCount10s }}
                    </td>
                    <td align="end">
                      {{ item.intervalAverageCount30s }}
                    </td>
                    <td align="end">
                      {{ item.intervalAverageCount60s }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FractionalBar from '../../components/FractionalBar.vue'

export default {
  created () {
    setInterval(() => {
      this.loadStats()
    }, this.requisitionInterval)
  },
  components: {
    FractionalBar
  },
  data () {
    return {
      requisitionInterval: 500,
      startAndStop: true,
      globalStatsList: [],
      wct: 0,
      now: 0,
      start: 0,
      last: 0,

      dataResponse: {},

      allAverageList: [],
      rsaAverageList: [],
      dsaAverageList: [],
      eccAverageList: [],
      ecxAverageList: [],
      aesAverageList: [],
      desAverageList: [],
      cspAverageList: [],
      bchainAverageList: [],
      x509AverageList: [],
      pkcs7AverageList: [],

      allCountList: [],
      rsaCountList: [],
      dsaCountList: [],
      eccCountList: [],
      ecxCountList: [],
      aesCountList: [],
      desCountList: [],
      cspCountList: [],
      bchainCountList: [],
      x509CountList: [],
      pkcs7CountList: [],

      firstInterval: 5,
      secondInterval: 10,
      thirdInterval: 30,
      fourthInterval: 60,

      colorList: [
        '#FFFFFF',
        '#F7DC6F',
        '#3498DB',
        '#2ECC71',
        '#9B59B6',
        '#E74C3C',
        '#1ABC9C',
        '#F39C12',
        '#FFC0CB',
        '#34495E'
      ],
      cardColorList: ['#F3F3F2', '#404040'],

      headers: [
        { text: this.$t('title_card'), align: 'start', sortable: true, value: 'title', width: '120px' },
        { text: this.$t('global_count'), align: 'end', sortable: true, value: 'count' },
        { text: this.$t('object_stats_start_s'), align: 'start', sortable: false, value: 'wctPresentation' },
        { text: this.$t('object_stats_last_s'), align: 'start', sortable: false, value: 'lastTouchPresentation' },
        { text: this.$t('average'), align: 'end', sortable: true, value: 'average' },
        { text: this.$t('variation_average'), align: 'end', sortable: true, value: 'averageVariation' },
        { text: this.$t('average_unit_5_seconds'), align: 'end', sortable: true, value: 'intervalAverageCount5s' },
        { text: this.$t('average_unit_10_seconds'), align: 'end', sortable: true, value: 'intervalAverageCount10s' },
        { text: this.$t('average_unit_30_seconds'), align: 'end', sortable: true, value: 'intervalAverageCount30s' },
        { text: this.$t('average_unit_60_seconds'), align: 'end', sortable: true, value: 'intervalAverageCount60s' }
      ]
    }
  },
  computed: {
    globalMonitorData () {
      const list = this.globalStatsList
      return list.sort((a, b) => b.count - a.count)
    },
    cardColunmWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 12
        case 'sm':
          return 6
        case 'md':
          return 6
        case 'lg':
        case 'xl':
          return 4
        default:
          return 4
      }
    },
    cardColor () {
      return this.$store.state.ui.darkModeEnabled ? this.cardColorList[1] : this.cardColorList[0]
    },

    fractionalData () {
      const counts = this.countsObjectList().slice(1)
      const colors = this.colorsObjectList().slice(1)

      const names = this.objectNameList().slice(1)

      const total = counts.reduce((a, b) => a + b, 0)

      const result = counts.map((count, index) => {
        return {
          value: counts[index],
          percent: (count / total) * 100,
          color: colors[index],
          name: names[index]
        }
      })

      return result
    }

  },
  methods: {
    loadStats () {
      this.$store
        .dispatch('hsm/getSLObjectStatistic')
        .then(res => {
          if (this.startAndStop === true) {
            this.mountDataAll(res.all)
            this.mountDataRsa(res.rsa)
            this.mountDataX509(res.x509)
            this.mountDataDes(res.des)
            this.mountDataEcc(res.ecc)
            this.mountDataEcx(res.ecx)
            this.mountDataAes(res.aes)
            this.mountDataBchain(res.bchain)
            this.mountDataPkcs7(res.pkcs7)
            this.mountDataCsp(res.csp)
            this.mountDataDsa(res.dsa)
          }
        })
    },
    colorsObjectList () {
      return this.globalMonitorData.map(item => {
        return item.color
      })
    },
    countsObjectList () {
      return this.globalMonitorData.map(item => {
        return item.count
      })
    },
    objectNameList () {
      const nameList = this.globalStatsList.map(item => {
        return item.title
      })

      return nameList
    },
    mountDataAll (all) {
      const count = all.count
      const start = all.start / 1000000 // Convert difference from microseconds to seconds
      const last = all.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(all.swct * 1000)
      let averageVariation = 0

      const now = new Date()

      this.start = wct
      this.last = last
      this.now = this.$getDateString({ date: now, timeDetailLevel: 2 })

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (all.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, all.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.allAverageList.push({ average, interval })

      if (this.allAverageList.length > 5) {
        this.allAverageList.shift()
      }

      if (this.allAverageList.length >= 2) {
        const rateSubList = this.allAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.allCountList.push({ seconds, count })

      const countList = this.allCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'Total', id: 'total', firstRow: true, color: this.colorList[0], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataRsa (rsa) {
      const count = rsa.count
      const start = rsa.start / 1000000 // Convert difference from microseconds to seconds
      const last = rsa.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(rsa.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (rsa.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, rsa.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.rsaAverageList.push({ average, interval })

      if (this.rsaAverageList.length > 5) {
        this.rsaAverageList.shift()
      }

      if (this.rsaAverageList.length >= 2) {
        const rateSubList = this.rsaAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.rsaCountList.push({ seconds, count })

      const countList = this.rsaCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'RSA', id: 'rsa', color: this.colorList[1], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataDsa (dsa) {
      const count = dsa.count
      const start = dsa.start / 1000000 // Convert difference from microseconds to seconds
      const last = dsa.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(dsa.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (dsa.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, dsa.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.dsaAverageList.push({ average, interval })

      if (this.dsaAverageList.length > 5) {
        this.dsaAverageList.shift()
      }

      if (this.dsaAverageList.length >= 2) {
        const rateSubList = this.dsaAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.dsaCountList.push({ seconds, count })

      const countList = this.dsaCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'DSA', id: 'dsa', color: this.colorList[2], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataEcc (ecc) {
      const count = ecc.count
      const start = ecc.start / 1000000 // Convert difference from microseconds to seconds
      const last = ecc.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(ecc.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (ecc.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, ecc.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.eccAverageList.push({ average, interval })

      if (this.eccAverageList.length > 5) {
        this.eccAverageList.shift()
      }

      if (this.eccAverageList.length >= 2) {
        const rateSubList = this.eccAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.eccCountList.push({ seconds, count })

      const countList = this.eccCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'ECC', id: 'ecc', color: this.colorList[3], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataEcx (ecx) {
      const count = ecx.count
      const start = ecx.start / 1000000 // Convert difference from microseconds to seconds
      const last = ecx.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(ecx.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (ecx.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, ecx.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.ecxAverageList.push({ average, interval })

      if (this.ecxAverageList.length > 5) {
        this.ecxAverageList.shift()
      }

      if (this.ecxAverageList.length >= 2) {
        const rateSubList = this.ecxAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.ecxCountList.push({ seconds, count })

      const countList = this.ecxCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'ECX', id: 'ecx', color: this.colorList[4], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataAes (aes) {
      const count = aes.count
      const start = aes.start / 1000000 // Convert difference from microseconds to seconds
      const last = aes.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(aes.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (aes.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, aes.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.aesAverageList.push({ average, interval })

      if (this.aesAverageList.length > 5) {
        this.aesAverageList.shift()
      }

      if (this.aesAverageList.length >= 2) {
        const rateSubList = this.aesAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.aesCountList.push({ seconds, count })

      const countList = this.aesCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'AES', id: 'aes', color: this.colorList[5], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataDes (des) {
      const count = des.count
      const start = des.start / 1000000 // Convert difference from microseconds to seconds
      const last = des.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(des.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (des.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, des.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.desAverageList.push({ average, interval })

      if (this.desAverageList.length > 5) {
        this.desAverageList.shift()
      }

      if (this.desAverageList.length >= 2) {
        const rateSubList = this.desAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.desCountList.push({ seconds, count })

      const countList = this.desCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'DES', id: 'des', color: this.colorList[6], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataCsp (csp) {
      const count = csp.count
      const start = csp.start / 1000000 // Convert difference from microseconds to seconds
      const last = csp.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(csp.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (csp.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, csp.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.cspAverageList.push({ average, interval })

      if (this.cspAverageList.length > 5) {
        this.cspAverageList.shift()
      }

      if (this.cspAverageList.length >= 2) {
        const rateSubList = this.cspAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.cspCountList.push({ seconds, count })

      const countList = this.cspCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'CSP', id: 'csp', color: this.colorList[7], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataBchain (bchain) {
      const count = bchain.count
      const start = bchain.start / 1000000 // Convert difference from microseconds to seconds
      const last = bchain.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(bchain.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (bchain.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, bchain.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.bchainAverageList.push({ average, interval })

      if (this.bchainAverageList.length > 5) {
        this.bchainAverageList.shift()
      }

      if (this.bchainAverageList.length >= 2) {
        const rateSubList = this.allAverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.bchainCountList.push({ seconds, count })

      const countList = this.bchainCountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'Blockchain', id: 'blockchain', color: this.colorList[8], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataX509 (x509) {
      const count = x509.count
      const start = x509.start / 1000000 // Convert difference from microseconds to seconds
      const last = x509.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(x509.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (x509.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, x509.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.x509AverageList.push({ average, interval })

      if (this.x509AverageList.length > 5) {
        this.x509AverageList.shift()
      }

      if (this.x509AverageList.length >= 2) {
        const rateSubList = this.x509AverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.x509CountList.push({ seconds, count })

      const countList = this.x509CountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'X.509', id: 'x509', color: this.colorList[9], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    mountDataPkcs7 (pkcs7) {
      const count = pkcs7.count
      const start = pkcs7.start / 1000000 // Convert difference from microseconds to seconds
      const last = pkcs7.last / 1000000 // Convert difference from microseconds to seconds
      const wct = new Date(pkcs7.swct * 1000)
      let averageVariation = 0

      let wctPresentation = '--/--/---- 00:00:00 GMT-0'
      let lastTouchPresentation = '--/--/---- 00:00:00 GMT-0'
      if (pkcs7.swct !== 0) {
        wctPresentation = this.$getDateString({ date: wct, timeDetailLevel: 2 })

        const lastTouch = this.calculateLastTouch(start, last, pkcs7.swct)
        lastTouchPresentation = this.$getDateString({ date: lastTouch, timeDetailLevel: 2 })
      }

      const now = new Date()

      const interval = (now - wct) / 1000
      const average = count / interval || 0

      this.pkcs7AverageList.push({ average, interval })

      if (this.pkcs7AverageList.length > 5) {
        this.pkcs7AverageList.shift()
      }

      if (this.pkcs7AverageList.length >= 2) {
        const rateSubList = this.pkcs7AverageList.slice(-2)
        const deltaRate = rateSubList[1].average - rateSubList[0].average
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        averageVariation = variation || 0
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      this.pkcs7CountList.push({ seconds, count })

      const countList = this.pkcs7CountList

      const intervalAverageCount5s = this.intervalAverageCalculator(count, seconds, this.firstInterval, countList)
      const intervalAverageCount10s = this.intervalAverageCalculator(count, seconds, this.secondInterval, countList)
      const intervalAverageCount30s = this.intervalAverageCalculator(count, seconds, this.thirdInterval, countList)
      const intervalAverageCount60s = this.intervalAverageCalculator(count, seconds, this.fourthInterval, countList)

      const newObj = { title: 'PKCS#7', id: 'pkcs7', color: this.colorList[10], count, start, last, wctPresentation, lastTouchPresentation, average: this.round(average), averageVariation: this.round(averageVariation), intervalAverageCount5s: this.round(intervalAverageCount5s), intervalAverageCount10s: this.round(intervalAverageCount10s), intervalAverageCount30s: this.round(intervalAverageCount30s), intervalAverageCount60s: this.round(intervalAverageCount60s) }
      this.globalStatsList = this.globalStatsList.filter((item) => item.title !== newObj.title)
      this.globalStatsList.push(newObj)
    },
    intervalAverageCalculator (currentCount, currentSeconds, interval, countList) {
      const counterPassedSeconds = countList.filter(item => {
        return item.seconds === currentSeconds - interval
      }).slice(-1)[0]?.count

      return (currentCount - counterPassedSeconds) / interval || null
    },
    calculateLastTouch (start, last, swct) {
      const diff = last - start
      const lastUse = swct + diff
      return new Date(lastUse * 1000)
    },
    round (num) {
      const m = Number((Math.abs(num) * 1000).toPrecision(12))
      const roudValue = Math.round(m) / 100 * Math.sign(num)
      return roudValue.toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.theme--light.striped tbody tr:nth-child(odd) {
  background-color: #f5f5f5;
}
.theme--dark.striped tbody tr:nth-child(odd) {
  background-color: #1b1b1b;
}
</style>
